import React, { Component } from 'react';
import { Button, Divider } from 'semantic-ui-react'
import * as moment from 'moment';

import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import ImageUploader from '../../../newSite/ImageUploader'
import Status from '../../../../config/OrderStatusConstants.js'
import * as Utils from '../../../../Utilities/Utils'
import { getOrderKey } from '../../../../config/constants';



function ShowKimotoExists(props) {

    const show = props.order.kimotoAvail
        ? <h5>Kimoto avail</h5>
        : ""

    return (
        <div>
            {show}
        </div>
    )
}

function KimotoNeededButton(props) {

    const showButton = props.order.kimotoAvail
        ? <h5>Kimoto avail</h5>
        : ""

    return (
        <Button color='pink' onClick={props.kimotoNeeded}>Kimoto Needed</Button>
    )
}

function UploadKimoto(props) {

    
   // const upload = props.order.status === Status.start_dsng_kimoto || props.order.status === Status.fin_dsng_kimoto
    const upload = props.order.status !== Status.new 
        ? <Button basic color='purple' >
            UPLOAD KIMOTO
        <ImageUploader
                updateWhenFileUploadComplete={props.updateWhenFileUploadComplete}
                storageReference={'kimotos'}
                fileName={props.order.order_num + '_kimoto'} />
        </Button>
        : ""

    return (
        <div>
            {upload}
        </div>
    )
}


export default class Kimoto extends Component {
    constructor(props) {
        super(props)

        this.state = ({
            kimotoUploadComplete: false
        })
    }

    kimotoNeeded = () => {
        console.log("++++++:kimotoNeeded");

        let kimotoStuff = {
            kimotoNeeded: true
        }

        let orderUpdate = {
            kimoto: kimotoStuff,
            kimotoNeeded: true
        }

        // FbUtils.updateOrder(this.props.order.key, orderUpdate);
    }



    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);
        console.log("this.props.user.email:" + this.props.user.email);

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            kimotoImageUrl: url,
            kimotoUpdated: now,
            kimotoAddedBy: this.props.user.email,
            lastUpdatedBy:this.props.user.email
        }

        //FbUtils.updateOrder(this.props.order.key, orderUpdates);
        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        this.setState({
            kimotoUploadComplete: true,
            actualFileName: actualFileName,
            kimotoImageUrl: url,
        });
        // this.props.history.push('/newOrder/thankYou');

        let daysSince = Utils.GetDaysSinceOrderPlaced(this.props.order.dateNum);
        let eventProperties = {
            user: this.props.user.email,
            daySinceOrderPlaced: daysSince,
            action: 'kimoto_uploaded'
        }
    }

    render() {

        const imageLink = this.props.order.kimotoImageUrl || this.state.kimotoUploadComplete
            ? <a href={this.props.order.kimotoImageUrl} target="_blank">VIEW KIMOTO</a>
            : <p>NO KIMOTO UPLOADED</p>


        const showAll = this.props.order.status !== Status.new 
            ? <div>
                <Divider horizontal>{'KIMOTO'}</Divider>
                <UploadKimoto
                    order={this.props.order}
                    updateWhenFileUploadComplete={this.updateWhenFileUploadComplete} />
                {imageLink}
            </div>
            : ""

        return (
            <div>
                {showAll}
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Kimotos/Kimoto.js